<template>
  <header class="jav-checkout-header-component">
    <section class="flex justify-between">
      <div class="col-left">
        <NuxtLink :to="homeLink.route">
          <img :src="homeLink.image" :alt="homeLink.text" class="logo h-8 lg:h-full" />
        </NuxtLink>
      </div>
      <div class="col-right">
        <template v-if="!loaderStore.getLoader">
          <CheckoutHeaderJavSteps />
        </template>
      </div>
    </section>
    <template v-if="getIsMobile">
      <div v-if="!loaderStore.getLoader" class="flex flex-col bg-neutral7">
        <div class="border-b border-neutral5 flex justify-center py-2">
          <CheckoutHeaderJavSteps />
        </div>
        <div v-if="checkoutStore.totalItems" class="border-b border-neutral5 px-4 py-2">
          <div class="bg-white dark:bg-dmGray1 border rounded-md border-neutral5 px-4">
            <CheckoutSummaryCart closed />
          </div>
        </div>
      </div>
    </template>
  </header>
</template>

<script lang="ts" setup>
import { Routes } from '~/enums/Routes'
import getLocalizedRoute from '~/utils/getLocalizedRoute'
import { useLoaderStore } from '~/store/loader'
import { useStoreConfig } from '~/store/storeConfig'
import { useCheckoutStore } from '~/store/checkout'

const logos = await useAssetManager().getLogos()

const loaderStore = useLoaderStore()
const { getIsMobile } = useStoreConfig()
const checkoutStore = useCheckoutStore()

const homeLink = computed(() => ({
  text: `Site Logo`,
  image: logos.logoWhite,
  route: getLocalizedRoute(Routes.Index),
}))
</script>

<style lang="postcss" scoped>
.jav-checkout-header-component {
  @apply bg-brand-primary flex flex-col lg:flex-row lg:justify-center;

  section {
    @apply flex items-center max-w-xlg w-full lg:px-[15px] gap-4 flex-wrap xl:flex-nowrap px-4 py-3;

    .col-left {
      @apply flex basis-full xl:basis-1/5;
    }

    .col-right {
      @apply hidden xl:flex basis-full xl:basis-1/5 justify-end ml-auto xl:ml-0;
    }
  }
}

.wl {
  .jav-checkout-header-component {
    @apply bg-white dark:bg-dmGray1 border-b border-neutral5;
  }
}
</style>
